import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('Tümü');

  const categories = ['Tümü', 'Schengen Vizesi', 'Amerika Vizesi', 'İngiltere Vizesi', 'Genel'];

  const blogPosts = [
    {
      title: '2026 Schengen Vize Şartları: Güncel Bilgiler ve Değişiklikler',
      slug: '2026-schengen-vize-sartlari',
      excerpt: 'Schengen vizesi başvurusu için 2026 yılında geçerli olan güncel şartlar, gerekli belgeler ve önemli değişiklikler hakkında detaylı bilgi.',
      image: 'https://public.readdy.ai/ai/img_res/fc5ef102896e5dfb166535a3e9670a9b.jpg',
      date: '15 Ocak 2026',
      category: 'Schengen Vizesi',
      readTime: '8 dk'
    },
    {
      title: 'Amerika Vize Mülakat Soruları ve Cevap Stratejileri',
      slug: 'amerika-vize-mulakat-sorulari',
      excerpt: 'ABD vize mülakatında sıkça sorulan sorular, doğru cevaplama teknikleri ve mülakat öncesi hazırlık ipuçları.',
      image: 'https://readdy.ai/api/search-image?query=usa%20visa%20interview%20preparation%20american%20flag%20passport%20documents%20professional%20consulting%20office%20modern%20bright%20setting&width=800&height=500&seq=blog2&orientation=landscape',
      date: '12 Ocak 2026',
      category: 'Amerika Vizesi',
      readTime: '10 dk'
    },
    {
      title: 'İngiltere Vize Ret Nedenleri ve Çözüm Önerileri',
      slug: 'ingiltere-vize-ret-nedenleri',
      excerpt: 'İngiltere vizesi neden reddedilir? En sık karşılaşılan ret nedenleri ve tekrar başvuru için yapılması gerekenler.',
      image: 'https://readdy.ai/api/search-image?query=uk%20visa%20rejection%20appeal%20documents%20british%20flag%20passport%20professional%20consulting%20office%20blue%20lighting%20modern%20composition&width=800&height=500&seq=blog3&orientation=landscape',
      date: '10 Ocak 2026',
      category: 'İngiltere Vizesi',
      readTime: '7 dk'
    },
    {
      title: 'Vize Reddi Sonrası Ne Yapmalı? Adım Adım Rehber',
      slug: 'vize-reddi-sonrasi-ne-yapmali',
      excerpt: 'Vize başvurunuz reddedildiyse panik yapmayın. İzlemeniz gereken adımlar ve tekrar başvuru stratejileri.',
      image: 'https://readdy.ai/api/search-image?query=visa%20rejection%20appeal%20process%20documents%20consultation%20professional%20advisor%20helping%20client%20modern%20office%20setting%20supportive%20atmosphere&width=800&height=500&seq=blog4&orientation=landscape',
      date: '8 Ocak 2026',
      category: 'Genel',
      readTime: '6 dk'
    },
    {
      title: 'İzmir\'den Schengen Vizesi Nasıl Alınır? Detaylı Rehber',
      slug: 'izmirden-schengen-vizesi-nasil-alinir',
      excerpt: 'İzmir\'de yaşayanlar için Schengen vizesi başvuru süreci, gerekli belgeler ve konsolosluk randevu bilgileri.',
      image: 'https://readdy.ai/api/search-image?query=izmir%20city%20view%20aegean%20sea%20schengen%20visa%20documents%20passport%20travel%20planning%20modern%20office%20consultation%20professional%20setting&width=800&height=500&seq=blog5&orientation=landscape',
      date: '5 Ocak 2026',
      category: 'Schengen Vizesi',
      readTime: '9 dk'
    },
    {
      title: 'Vize Başvurusunda Banka Hesap Özeti Nasıl Olmalı?',
      slug: 'vize-basvurusunda-banka-hesap-ozeti',
      excerpt: 'Vize başvurusu için banka hesap özetinde nelere dikkat edilmeli? Yeterli bakiye ve işlem geçmişi kriterleri.',
      image: 'https://readdy.ai/api/search-image?query=bank%20statement%20financial%20documents%20visa%20application%20money%20passport%20professional%20consultation%20modern%20office%20blue%20orange%20accents&width=800&height=500&seq=blog6&orientation=landscape',
      date: '3 Ocak 2026',
      category: 'Genel',
      readTime: '5 dk'
    }
  ];

  const filteredPosts = selectedCategory === 'Tümü' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary to-blue-600 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading font-bold text-4xl lg:text-5xl text-white mb-4">
            Vize Danışmanlık Blog
          </h1>
          <p className="font-body text-lg text-white/90 max-w-2xl mx-auto">
            Vize başvuruları, seyahat ipuçları ve güncel gelişmeler hakkında bilgilendirici yazılar
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-body font-semibold transition-all whitespace-nowrap ${
                  selectedCategory === category
                    ? 'bg-secondary text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post, index) => (
              <Link
                key={index}
                to={`/blog/${post.slug}`}
                className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all"
              >
                <div className="h-56 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="bg-secondary/10 text-secondary px-3 py-1 rounded-full font-body text-xs font-semibold">
                      {post.category}
                    </span>
                    <span className="font-body text-xs text-gray-500">{post.readTime}</span>
                  </div>
                  <h3 className="font-heading font-bold text-xl text-darkBlue group-hover:text-secondary transition-colors mb-2 line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="font-body text-gray-600 mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="font-body text-sm text-gray-500">{post.date}</span>
                    <span className="text-secondary group-hover:translate-x-2 transition-transform">
                      <i className="ri-arrow-right-line text-xl"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
